<template>

  <input 
    type="text" 
    class="form-control" 
    :value="valFormated"
    :placeholder="placeholder"
    @change="change($event.target.value)">

</template>

<script>
import enumber from '@/locales/enumber'

export default {
  name: 'InputMoney',
  props: {
    'value': {
      type: Number,
      default: null
    },
    'locale': {
      type: String,
      default: null
    },
    'placeholder': {
      type: String,
      default: null
    }
  },
  data () {
    return {
    }
  },
  computed: {
    valFormated () {
      if (this.value) {
        const money = this.$n(this.value, {style: 'decimal', minimumFractionDigits: 2})
        return money
      } else {
        return null
      }
    }
  },
  mounted () {
  },
  methods: {
    change (value) {
      const val = enumber(value, this.locale)
      this.$emit('input', val)
      this.$forceUpdate() // caso entre em o mesmo valor, força o update
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Fields/InputMoney.vue